var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"dropdown-item is-size-6",on:{"click":function($event){$event.preventDefault();return _vm.openContactForm.apply(null, arguments)}}},[(_vm.$cazana)?_c('span',{staticClass:"icon is-small has-text-danger"},[_c('i',{staticClass:"fas fa-user-headset"})]):_vm._e(),_c('span',[_vm._v(" "+_vm._s(_vm.contactText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }